import axios, { AxiosInstance } from 'axios'
import requestInterceptor from '../../requestInterceptor'
import responseInterceptor from '../../responseInterceptor'
import { internalApiUrl } from '../../../../urls'

const headers: Record<string, string> = {
	'Content-Type': 'application/json',
	'X-Requested-With': 'XMLHttpRequest',
}

const internalApiInstance: AxiosInstance = axios.create({
	baseURL: internalApiUrl,
	headers,
})

internalApiInstance.interceptors.request.use(requestInterceptor, error => Promise.reject(error))

internalApiInstance.interceptors.response.use(response => response, error => {
	return responseInterceptor(error)
})

export default internalApiInstance
